import React from "react";
import PropTypes from "prop-types";

import { withTheme, Dialog, withStyles } from "@material-ui/core";
import {
  // Favorite,
  // FavoriteBorderOutlined,
  // AddCircleOutline,
  // RemoveCircleOutline,
  Close,
  // ArrowRight,
  // CreditCard,
  // Redo,
  // Undo
} from "@material-ui/icons";
// import Swipe from "react-easy-swipe";
import { getImageUrl } from "../../framework/getImageUrl";
import s from "./saveDialog.module.css";
// import moment from "moment";
import { theme } from "../../framework/theme";
import GlobalContext from "../../context/globalContext";

// function Transition(props) {
//   return <Slide direction="down" in={true} {...props} />;
// }

const styles = {
  root: {},
  dialog: {
    minWidth: 400,
    padding: 0,
    justifySelf: "center",
    left: "-3%",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      left: 0,
    },
  },
};

class SaveDialog extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  chooseCurrentCII = async (currentItem) => {
    await this.context.global.confirmItemInCart(currentItem);
  };

  chooseAlternateCII = async (currentItem, alternativeItem) => {
    await this.context.global.modifyShoppingCart(
      alternativeItem,
      false,
      currentItem.quantityInCart
    );
    await this.context.global.modifyShoppingCart(
      currentItem,
      true,
      currentItem.quantityInCart
    );
    this.context.global.submitShoppingCartChanges();
  };

  closeChooseSavingsDialog = () => {
    this.context.global.setGlobalState("chooseSavingsDialogState", false);
  };

  render() {
    const { classes } = this.props;
    const { shoppingCart, chooseSavingsDialogState } = this.context.global.data;

    let alternativeList;
    if (shoppingCart) {
      alternativeList = shoppingCart.savingSuggestions;
    } else {
      return null;
    }
    if (alternativeList.length === 0) {
      return null;
    }

    let currentItem;
    let alternativeItem;
    currentItem = alternativeList[0].currentCalculatedInventoryItem;
    alternativeItem = alternativeList[0].suggestedCalculatedInventoryItem;

    return (
      <Dialog
        open={chooseSavingsDialogState}
        className={classes.dialog}
        onClose={this.closeChooseSavingsDialog}
        style={{ zIndex: 90002 }}
      >
        <div className={s.contentContainer}>
          <div className={s.topBar}>
            <div />
            <div style={{ flex: 1 }}>Choose the one to keep!</div>
            <div className={s.content}>
              <Close
                fontSize={"small"}
                onClick={this.closeChooseSavingsDialog}
              />
            </div>
          </div>
          <div className={s.content}>
            <div
              className={s.left}
              onClick={async () => {
                await this.chooseCurrentCII(currentItem);
                if (alternativeList.length < 1) {
                  await this.closeChooseSavingsDialog;
                }
              }}
            >
              <div className={s.title}>You chose</div>
              <div className={s.productImage}>
                <img src={getImageUrl(currentItem.imageUrl)} alt={""} />
              </div>
              <div className={s.productName}>
                {currentItem.brand} {currentItem.name}
              </div>
              <div className={s.productWeight}>
                <span
                  style={{
                    color: theme.palette.primary.main,
                    fontWeight: 600,
                    paddingRight: 5,
                  }}
                >
                  ${(currentItem.basePrice / currentItem.size / 100).toFixed(2)}
                  /{currentItem.sizeUnits}
                </span>{" "}
                | {currentItem.calories}cal
              </div>
            </div>
            <div
              className={s.right}
              onClick={async () => {
                await this.chooseAlternateCII(currentItem, alternativeItem);
                if (alternativeList.length - 1 === 0) {
                  await this.closeChooseSavingsDialog();
                }
              }}
            >
              <div className={s.title}>
                Save{" "}
                {(
                  (1 - alternativeItem.basePrice / currentItem.basePrice) *
                  100
                ).toFixed(0)}
                % on
              </div>
              <div className={s.productImage}>
                <img src={getImageUrl(alternativeItem.imageUrl)} alt={""} />
              </div>
              <div className={s.productName}>
                {alternativeItem.isSelect
                  ? "FF Select "
                  : alternativeItem.brand}
                {alternativeItem.name}
              </div>
              <div className={s.productWeight}>
                <span
                  style={{
                    color: theme.palette.primary.main,
                    fontWeight: 600,
                    paddingRight: 5,
                  }}
                >
                  $
                  {(
                    alternativeItem.basePrice /
                    alternativeItem.size /
                    100
                  ).toFixed(2)}
                  /{alternativeItem.sizeUnits}
                </span>{" "}
                | {alternativeItem.calories}cal
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

SaveDialog.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTheme()(withStyles(styles)(SaveDialog));
